import { useState } from "react";
import { useTranslate } from "react-admin";
import { capitalize } from "underscore.string";
import { useFormContext } from "react-hook-form";
import CustomTimeInput from "./CustomTimeInput";
import { Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

const daysData = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];

const getTimeOfDayInMilliseconds = (date: any) => {
  const hours = date.hour() * 60 * 60 * 1000;
  const minutes = date.minute() * 60 * 1000;
  return hours + minutes;
};

const CustomDaysTimePicker = ({ setRerenderTimezone }: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_forceRenderParentComponent, setForceRenderParentComponent] =
    useState<boolean>(false);
  const [applyAllDates, setApplyAllDates] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [days, setDays] = useState<any>(daysData);
  const [selectedDayToRemove, setSelectedDayToRemove] = useState<string>("");
  const form = useFormContext();
  const formValues = form.getValues();
  const timezone = formValues?.timezone || "PST8PDT";
  const translate = useTranslate();
  const hoursOpen = form?.getValues("monday_hours_open");
  const hoursClose = form?.getValues("monday_hours_close");

  const handleApplyToAllDates = () => {
    if (!hoursOpen || !hoursClose) return;
    for (let item of days) {
      form.setValue(`${item}_hours_open`, hoursOpen);
      form.setValue(`${item}_hours_close`, hoursClose);
    }
    setApplyAllDates(true);
    setTimeout(() => {
      setApplyAllDates(false);
    }, 1500);
  };

  const handleRemoveSelectedDay = (day: string) => {
    setSelectedDayToRemove(day);
    setTimeout(() => {
      setSelectedDayToRemove("");
    }, 1500);
  };
  return (
    <div>
      {days.map((day: string, i: number) => {
        const openHourCheck = form?.getValues(`${day}_hours_open`);
        const closeHourCheck = form?.getValues(`${day}_hours_close`);
        // const test1 = moment("1970-01-01")
        //   .set("h", moment(openHourCheck).tz(timezone).hours())
        //   .tz(timezone);
        // const test2 = moment("1970-01-01")
        //   .set("h", moment(closeHourCheck).tz(timezone).hours())
        //   .tz(timezone);
        // const isInvalidTime = test1?.isAfter(test2);
        const openHourCheckWithTimezone = dayjs(openHourCheck).tz(timezone);
        const closeHourCheckWithTimezone = dayjs(closeHourCheck).tz(timezone);

        const start = getTimeOfDayInMilliseconds(openHourCheckWithTimezone);
        const end = getTimeOfDayInMilliseconds(closeHourCheckWithTimezone);

        const isInvalidTime = start >= end;
        return (
          <div key={day}>
            <p>{capitalize(translate(`locations.${day}`))}</p>
            <div style={{ display: "flex", marginBottom: "16px", gap: "16px" }}>
              <CustomTimeInput
                form={form}
                timezone={timezone}
                source={`${day}_hours_open`}
                label="locations.open"
                autoGeneratedDate={
                  applyAllDates && hoursOpen && hoursClose && hoursOpen
                }
                setForceRenderParentComponent={setForceRenderParentComponent}
                day={day}
                selectedDayToRemove={selectedDayToRemove}
                isInvalidTime={!!isInvalidTime}
              />
              <CustomTimeInput
                form={form}
                timezone={timezone}
                source={`${day}_hours_close`}
                label="locations.close"
                autoGeneratedDate={
                  applyAllDates && hoursOpen && hoursClose && hoursClose
                }
                setForceRenderParentComponent={setForceRenderParentComponent}
                day={day}
                selectedDayToRemove={selectedDayToRemove}
                isInvalidTime={!!isInvalidTime}
              />
              {(openHourCheck || closeHourCheck) && (
                <IconButton
                  className="w-[24px] h-[24px] self-center"
                  onClick={() => handleRemoveSelectedDay(day)}
                >
                  <CloseIcon style={{ width: "16px", height: "16px" }} />
                </IconButton>
              )}
              {i === 0 && hoursOpen && hoursClose && (
                <Button
                  sx={{
                    alignSelf: "flex-end",
                    height: "51px",
                    padding: "0px 12px",
                    border: "solid 1px rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                    textTransform: "none",
                    fontSize: "16px",
                    fontFamily: "Inter",
                    fontWeight: 500,
                    color: "rgba(48, 47, 46, 0.95)",
                    marginTop: "3px",
                    marginBottom: "3px"
                  }}
                  type="button"
                  onClick={handleApplyToAllDates}
                >
                  Apply to all
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CustomDaysTimePicker;
